<template>
  <modal
    v-slot="{ data }"
    name="locationDetails"
  >
    <location-details :data="data" />
  </modal>
</template>


<script>
  import LocationDetails from './location-details/index.vue';


  export default {
    name: 'LocationDetailsModal',

    components: {
      LocationDetails
    }
  };
</script>
